import React, { useState, useEffect } from "react";
import axios from "axios";
import "./WeatherForecast.css";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [weatherForecast, setWeatherForecast] = useState(false);
  let [forecast, setForecast] = useState(null);
  let [searching, setSearching] = useState(true);
  function handleResponse2(response) {
    setWeatherForecast(true);
    setForecast(response.data.daily);
  }
  function search() {
    const apiKey = "aa4oftad8baaee9e63b2667c02fe71b9";
    let apiURL2 = `https://api.shecodes.io/weather/v1/forecast?query=${props.city}&key=${apiKey}`;
    axios.get(apiURL2).then(handleResponse2);
  }
  useEffect(() => {
    setWeatherForecast(false);
  }, [props.city]);
  if (searching === false) {
    if (weatherForecast) {
      return (
        <div className="forecast">
          <div className="row">
            {forecast.map(function (dailyForecast, index) {
              if (index < 5) {
                return (
                  <span className="col" key={index}>
                    <WeatherForecastDay
                      city={props.city}
                      forecast={forecast[index]}
                    />
                  </span>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      );
    } else {
      search();
      return null;
    }
  } else {
    setSearching(props.searching);
    return "Loading...";
  }
}
